module.exports = __webpack_public_path__ + "img/report_page_navigation.7648a705.svg";